import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  initialize() {
    if (navigator.userAgent.indexOf("Mac") != -1) {
      this.element.classList.add("os-mac")
    } else {
      this.element.classList.add("os-other")
    }
  }
}
